var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPython = function SvgPython(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a79b2",
    d: "M9.914.005C4.849.005 5.165 2.21 5.165 2.21l.006 2.284h4.833v.686H3.251S.01 4.811.01 9.942s2.829 4.949 2.829 4.949h1.688V12.51s-.091-2.84 2.784-2.84h4.794s2.693.044 2.693-2.613V2.664S15.207.005 9.914.005zM7.249 1.541c.481 0 .87.39.87.873a.87.87 0 1 1-1.74 0 .87.87 0 0 1 .87-.873z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdb10",
    d: "M10.058 19.931c5.065 0 4.749-2.205 4.749-2.205l-.006-2.284H9.968v-.686h6.753s3.241.369 3.241-4.762-2.829-4.949-2.829-4.949h-1.688v2.381s.091 2.84-2.784 2.84H7.867s-2.693-.044-2.693 2.613v4.393s-.409 2.658 4.884 2.658zm2.665-1.537c-.481 0-.87-.39-.87-.873a.87.87 0 1 1 1.74 0 .87.87 0 0 1-.87.873z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPython);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;